<template>
  <div v-bind:style="additionalContainerCss" class="container">
    <!-- eslint-disable -->
    <div
      ref="detail"
      v-bind:class="{'default': !expanded, 'expanded': expanded}"
      v-bind:style="`--lines: ${lines}`"
    >
      <div v-bind:style="additionalCss">
        <slot />
      </div>
    </div>
    <!-- eslint-enable -->
    <a
      v-if="hasMore && triggerShowMore"
      :style="additionalAnchorCss"
      @click="onClick"
      class="anchor"
    >{{ moreText }}</a>
    <a
      v-if="hasMore && expanded"
      :style="additionalAnchorCss"
      @click="onClick"
      class="anchor"
    >{{ lessText }}</a>
  </div>
</template>

<script>
export default {
  props: {
    lines: {
      type: Number,
      default: 3,
    },
    text: {
      type: String,
      default: '',
    },
    additionalContainerCss: {
      type: String,
      default: '',
    },
    additionalContentCss: {
      type: String,
      default: '',
    },
    additionalContentExpandedCss: {
      type: String,
      default: '',
    },
    hasMore: {
      type: Boolean,
      default: true,
    },
    moreText: {
      type: String,
      default: 'Показать еще',
    },
    lessText: {
      type: String,
      default: 'Скрыть',
    },
    additionalAnchorCss: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      expanded: false,
      triggerShowMore: false,
    }
  },
  computed: {
    additionalCss () {
      if (this.expanded) {
        return this.additionalContentCss
      } else {
        return this.additionalContentExpandedCss
      }
    },
  },
  mounted () {
    this.$nextTick(function () {
      this.determineShowMore()
    })
  },
  updated () {
    this.$nextTick(function () {
      this.determineShowMore()
    })
  },
  methods: {
    onClick () {
      this.expanded = !this.expanded
      this.$emit('click', this.expanded)
    },
    determineShowMore () {
      if (
        this.$refs.detail &&
          this.$refs.detail.offsetHeight < this.$refs.detail.scrollHeight
      ) {
        this.triggerShowMore = true
      } else {
        this.triggerShowMore = false
      }
    },
  },
}
</script>
<style scoped>

.default {
  --lines: 3;
  white-space: pre-line;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: var(--lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: fade;
}

.expanded {
  display: block;
  display: -webkit-box;
  /*/white-space: pre-line;*/
}

.anchor {
  display: block;
  text-align: center;
  padding: 10px 0 8px 0;
  margin-bottom: 4px;
  color: #C2C2C2;
  font-size: 12px;
  cursor: pointer;
  font-weight: 300;
}

</style>
